var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-alert',{staticClass:"mb-2",attrs:{"type":_vm.alertType}},[_c('install-agent-form',{attrs:{"slot":"message","data":_vm.data,"serverColumns":_vm.serverColumns,"isPageDestroyed":_vm.isPageDestroyed},on:{"onInstall":_vm.handleInstallResult},slot:"message"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }